import React from "react";
import JME from './jme3.js';
import './resources/css/jme3.css';

var $ = require("jquery");
export default class Equation extends React.Component 
{    
    state={isnew:true};

    componentDidMount() {
        console.log("Equation:cdm");
        this.$el = $(this.el);
        var options={'theme':'latin_modern_serif_italic','size':'12'};
        var md=null;
        if(this.props.mathData.eqn!=undefined && this.props.mathData.eqn.length>1)
        {
            md=this.props.mathData.eqn;
            this.setState({isnew:false});
        }
        this.jme = new JME(process.env.REACT_APP_JEQ_EP,"jmeDiv",md,options);
    }
    componentDidUpdate(prevProps,prevState)
    {
    }
    componentWillUnmount() {
        //this.$el.somePlugin('destroy');
        //TODO close socket
    }
    getMathML=(callback)=>{
        this.jme.jmeGetMathML(callback);
    }
    getPNG=(callback)=>{
        this.jme.jmeGetPNG(callback);
    }
    setMathML=(mathData)=>{
        this.jme.jmeLoadEquation(mathData);
        this.setState({isnew:false});
    }
    render()
    {
        return(
            <>
                <div id="jmeDiv" ref={el => this.el = el} />   
            </>
        );    
    }
}